var _line, _path, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 23,
    viewBox: "0 0 416 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 11,
    x2: 184,
    y2: 11,
    stroke: "#C5C5C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.773 17.6818C203.985 17.6818 203.294 17.4943 202.699 17.1193C202.108 16.7443 201.646 16.2197 201.312 15.5455C200.983 14.8712 200.818 14.0833 200.818 13.1818C200.818 12.2727 200.983 11.4792 201.312 10.8011C201.646 10.1231 202.108 9.59659 202.699 9.22159C203.294 8.84659 203.985 8.65909 204.773 8.65909C205.561 8.65909 206.25 8.84659 206.841 9.22159C207.436 9.59659 207.898 10.1231 208.227 10.8011C208.561 11.4792 208.727 12.2727 208.727 13.1818C208.727 14.0833 208.561 14.8712 208.227 15.5455C207.898 16.2197 207.436 16.7443 206.841 17.1193C206.25 17.4943 205.561 17.6818 204.773 17.6818ZM204.773 16.4773C205.371 16.4773 205.864 16.3239 206.25 16.017C206.636 15.7102 206.922 15.3068 207.108 14.8068C207.294 14.3068 207.386 13.7652 207.386 13.1818C207.386 12.5985 207.294 12.0549 207.108 11.5511C206.922 11.0473 206.636 10.6402 206.25 10.3295C205.864 10.0189 205.371 9.86364 204.773 9.86364C204.174 9.86364 203.682 10.0189 203.295 10.3295C202.909 10.6402 202.623 11.0473 202.438 11.5511C202.252 12.0549 202.159 12.5985 202.159 13.1818C202.159 13.7652 202.252 14.3068 202.438 14.8068C202.623 15.3068 202.909 15.7102 203.295 16.017C203.682 16.3239 204.174 16.4773 204.773 16.4773ZM210.774 17.5V8.77273H212.07V10.0909H212.161C212.32 9.65909 212.607 9.30871 213.024 9.03977C213.441 8.77083 213.911 8.63636 214.433 8.63636C214.532 8.63636 214.655 8.63826 214.803 8.64205C214.95 8.64583 215.062 8.65152 215.138 8.65909V10.0227C215.092 10.0114 214.988 9.99432 214.825 9.97159C214.666 9.94508 214.498 9.93182 214.32 9.93182C213.895 9.93182 213.517 10.0208 213.183 10.1989C212.854 10.3731 212.592 10.6155 212.399 10.9261C212.21 11.233 212.115 11.5833 212.115 11.9773V17.5H210.774Z",
    fill: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 232,
    y1: 11,
    x2: 416,
    y2: 11,
    stroke: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrSeparator);
export default __webpack_public_path__ + "static/media/or_separator.c8f8327e742938199bc94a33226685d2.svg";
export { ForwardRef as ReactComponent };